define('viewmodels/footer',['underscore', 'knockout'], function (_, ko) {
    var FooterViewModel = function(session, getField) {
        this.session = session;

        this.licensesTitleText = getField('licenses_title_text');
        this.legalInfo = getField('legal_info');
        this.termsLinkText = getField('terms_link_text');
        this.cookiePolicyText= getField('cookie_link_text');
        this.contactUsLinkText = getField('contact_us_link_text');
        this.mgaLogoImageUrl = getField('mga_logo_image_url');
        this.gamblingCommissionLogoImageUrl = getField('gambling_commission_logo_image_url');
        this.gamcareLogoImageUrl = getField('gamcare_logo_image_url');
        this.ageLogoImageUrl = getField('age_logo_image_url');
        this.paymentLogosImageUrls = ko.deferredComputed(function() {
            return _.map(getField('payment_logos')(), 'image_url');
        });
        this.paymentSidebarLogos = ko.deferredComputed(function() {
            return _.map(getField('payment_sidebar_logos')(), 'image_url');
        });

        this.infoCollapsed = ko.observable(true);
        this.toggleInfo = function() {
            this.infoCollapsed(!this.infoCollapsed());
        };
    };

    return FooterViewModel;
});

